import React, { useState } from 'react';
import ProcessingIndicator from '../../../Common/ProcessingIndicator';
import { Grid, Button } from '@material-ui/core';
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import Alert from "@material-ui/lab/Alert";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import Box from "@material-ui/core/Box";
import UseGPIPayFields from './UseGPIPayFields';
import { useDispatch, useSelector } from 'react-redux';
import {
    getGPIData,
    getPaymentData,
    setGPICard,
    setGPIError,
    getPayorData,
    getFacilityInfo,
} from '../../../../Store/purchase.slice';
import GPICreditCardFields from './GPICreditCardFields';

const GPICreditCardForm = () => {
    const dispatch = useDispatch();
    const payorData = useSelector(getPayorData);
    const gpiData = useSelector(getGPIData);
    const facility = useSelector(getFacilityInfo);
    const paymentData = useSelector(getPaymentData);
    const [editToken, setEditToken] = useState(gpiData.cards.length < 1);
    const [saveInProgress, setSaveInProgress] = useState(false);
    const [street, setStreet] = useState(payorData.billing_street);
    const [zip, setZip] = useState(payorData.billing_zip);

    return <Grid container spacing={3}>
        {facility.use_ach && paymentData.hasCreditCardFee && <Grid item xs={12}><Typography variant='caption'>
            Select ACH Payment to avoid paying an additional credit card fee.
        </Typography></Grid>}
        {!!editToken ? <>
            <UseGPIPayFields setEditToken={setEditToken} setSaveInProgress={setSaveInProgress} street={street} zip={zip} />
            <GPICreditCardFields />
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Street Address"
                    name="gpi-address"
                    variant="outlined"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={street}
                    onChange={event => setStreet(event.target.value)}
                    inputProps={{"data-cy": "credit-card-add-address-input"}}
                />
            </Grid>
            <Grid item xs={12} sm={6}>
                <TextField
                    label="Zip Code"
                    name="gpi-zip"
                    variant="outlined"
                    required
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    value={zip}
                    onChange={event => setZip(event.target.value)}
                    inputProps={{"data-cy": "credit-card-add-zip-code-input"}}
                />
            </Grid>
            {gpiData.error ? <Grid item xs={12}><Alert severity="error" data-cy="credit-card-add-alert">{gpiData.error}</Alert></Grid> : ''}
        </> : <Grid item xs={12}>
            <List>
                {gpiData.cards.map((c, i) => <ListItem key={c.token} selected={c.token === gpiData.default_source}
                                                       onClick={() => dispatch(setGPICard(c.token))} button data-cy={`credit-card-option-${i}`}>
                    <ListItemText primary={`${c.type} ending in ${c.last4}`}
                                  secondary={`Expires on ${c.exp_month}/${c.exp_year}`}
                                  primaryTypographyProps={{"data-cy": "credit-card-option-card-number-text"}}
                                  secondaryTypographyProps={{"data-cy": "credit-card-option-expiration-text"}}/>
                </ListItem>)}
            </List>
        </Grid>}
        <Grid item xs={12}>
            {!!editToken ? 
                <Box display="flex" justifyContent="space-between">
                    <Button variant="outlined" color="secondary"
                            onClick={() => {
                                setEditToken(false);
                                dispatch(setGPIError(null));
                            }}
                            data-cy="credit-card-add-cancel-button"
                    >Cancel</Button>
                    {saveInProgress ?
                        <ProcessingIndicator userMessage="Saving..." />
                        :       
                        <div id="submit-gpi" data-cy="credit-card-submit-button-container"></div>
                    }
                </Box>
                :
                <Button variant="contained" color="primary"
                        onClick={() => setEditToken(true)} data-cy="credit-card-add-button">Add Credit Card</Button>
            }
        </Grid>
    </Grid>
};

export default GPICreditCardForm;
